<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <!-- <div class="col-sm-12"> -->
          <div class="row">
            <div class="col-sm-12">
                <vs-breadcrumb align="left" :items="
                  [
                    {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/program-officer/todoList'
                    },
                    {
                      title: training.title,
                      url: '/#/dashboard/program-officer/todoList'
                    },
                    {
                      title: 'Trainee`s Approval',
                      active: true
                    }
                  ]
                    ">
                </vs-breadcrumb>
              <div class="heading mt-3">
                <h3 class="text-secondary">Trainees Approval</h3>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="col-sm-12">
              <div class="table-responsive">
                <table class="table table-hover">
                  <tr>
                    <th>Sr#</th>
                    <th>Name</th>
                    <th>Username</th>
                    <th>Code</th>
                    <th>Added at</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                  <tr v-for="(item, index) in traineeArr" v-bind:key="item.id">
                    <td>{{index+1}}</td>
                    <td class="text-capitalize">{{item.name}}</td>
                    <td>{{item.username}}</td>
                    <td>{{item.code}}</td>
                    <td>{{item.createdAt | formatDate}}</td>
                    <td>
                      <vs-chip v-if="item.statusApproval == '1'" color="primary">Pending</vs-chip>
                      <vs-chip v-if="item.statusApproval == '2'" color="success">Approved</vs-chip>
                      <vs-chip v-if="item.statusApproval == '3'" color="danger">Reject</vs-chip>
                    </td>
                    <td>
                      <a @click="approvedTrainee(item.id)">
                        <vs-icon
                          class="mr-1"
                          icon="check"
                          style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;" 
                        ></vs-icon>
                      </a>
                      <a @click="rejectTrainee(item.id)">
                        <vs-icon
                          class="mr-1"
                          icon="close"
                          style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"
                           ></vs-icon>
                      </a>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./subSidebar";
import axios from "axios";
export default {
  data: () => ({
    isSidebar: false,
    trainingId: "",
    trainingCode: "",
    traineeArr: [],
    training: '',
  }),
  mounted() {
    this.trainingCode = this.$route.query.trainingId;
    this.getCurrentTraining();
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 10000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 10000,
        variant: "danger",
        solid: true
      });
    },
    // this will get current training
    getCurrentTraining(){
    this.openLoading();
    axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/programOfficer/trainingsingle/get/" +
          this.trainingCode
      ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.training = response.data.training;
        this.trainingId = response.data.training.id;
        this.getTrainee();
      });
    },
    getTrainee() {
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/trainee/get/all/" +
            this.trainingId
        ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.traineeArr = response.data;
        });
    },
    approvedTrainee(id) {
      let self = this;
      this.openLoading();
      axios
        .post(localStorage.getItem("BASE_PATH") + "/trainee/single/update", {
          statusApproval: 2,
          id: id
        },{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data.success) {
            self.$toasted.global.successMsg("Trainee has been approved successfully!");
            this.getTrainee();
          } else if (response.data.error) {
            throw response.data.error;
          }
        })
        .catch(error => {
          self.$toasted.global.errorMsg(error);
        });
    },
    rejectTrainee(id) {
      let self = this;
      this.openLoading();
      axios
        .post(localStorage.getItem("BASE_PATH") + "/trainee/single/update", {
          statusApproval: 3,
          id: id
        },{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data.success) {
            self.$toasted.global.successMsg("Trainee has been rejected successfully!");
            this.getTrainee();
          } else if (response.data.error) {
            throw response.data.error;
          }
        })
        .catch(error => {
          self.$toasted.global.errorMsg(error);
        });
    }
  },
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  }
};
</script>

<style scoped>
</style>